import { Injectable } from '@angular/core';
import { plainToClass } from 'class-transformer';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RestService } from '../../shared/service/rest.service';
import { AdditionalInfoImpl } from '../model/status/additional-info-impl';
import { Device } from '../model/device';

@Injectable()
export class DeviceStatusService extends RestService {

    getVehiclesDevicesStatuses(devices: Device[]): Observable<AdditionalInfoImpl[]> {
        const payload = devices.map(d => ({
            deviceId: d.devId,
            deviceType: d.deviceType,
            sideNumber: (d.vehicle as any).veh_side_number
        }));
        return this.doPost<AdditionalInfoImpl[]>('api/devices/status', payload)
            .pipe(
                map(devs => devs.filter(dev => dev != undefined).map(dev => plainToClass(AdditionalInfoImpl, dev)))
            );
    }
}
